import React, { useEffect, useRef, useState } from "react";
import {
  formatCurrency,
  formatToLocalDate,
  ROLE,
  useDebounce,
} from "../../../../helpers/utils";
import { svg } from "../../../../Assets/svg";
import { useNavigate } from "react-router-dom";
import {
  CreateQuotationStepsEnum,
  QuoteStatus,
  QuoteStatusLabels,
  WarningSeverity,
} from "../../Quotations/quotationTypes";
import {
  Dropdown,
  Menu,
  message,
  Spin,
  Table,
  TableColumnsType,
  Tooltip,
} from "antd";
import { RoleTypesEnum } from "../../RolesAndPermissions/rolesAndPermissionsTypes";
import { useAppDispatch, useAppSelector } from "../../../../store";
import {
  deleteQuotationAPI,
  duplicateQuotationAPI,
  createRevisionQuotationAPI,
  generateQuotationPdfAPI,
  fetchQuotationsQueryFn,
  getQuotationsListAPI,
  notifyClientAPI,
  reopenQuotationAPI,
  updateQuotatioStatusAPI,
} from "../../Quotations/quotationApis";
import {
  decryptByText,
  getDecryptedName,
  getDecryptedUserData,
  isCustomerLoggedIn,
  isAdminSubAdminLoggedIn,
} from "../../../../helpers/bycrypt";
import AddApprovalOverrideNoteModal from "../../Quotations/Components/AddApprovalOverrideNoteModal";

import {
  QUOTATION_FILTER_KEY,
  QUOTATION_REFETCH_KEY,
  QUOTATION_SCROLL_KEY,
} from "../../Quotations/quotationTypes";

import FullScreenLoader from "../../../Components/FullScreenLoader";
import NoDataMessage from "../../../Components/NoData";
import InfiniteScroll from "react-infinite-scroll-component";
import { statusFindClass } from "../../Quotations/Quotations";
import {
  PagePermissionNameData,
  usePermissionsChecker,
} from "../../../../helpers/permissionModule";
import { CommonConfirmationModal } from "../../../../Components/CommonConfirmationModal";

import { createOrderAPI } from "../../Orders/orderApis";
import { ModifyDeliveryAddressModal } from "./ModifyDeliveryAddressModal";
import CreateOrderConfirmationModal from "../../Quotations/Components/CreateOrderConfirmationModal";
import {
  WarningActionLayouts,
  WarningsModal,
} from "../../../../Components/WarningsModal";
import ViewProfitDataModal from "../../Orders/Components/Modals/ViewProfitDataModal";
import ConfigureDrawingsModal from "../../Quotations/Components/ConfigureDrawingsModal";
import { Capacitor } from "@capacitor/core";
import { getCapacitorBaseUrl } from "../../../../helpers/common";
import CustomerOnHoldWarningModal from "../../Orders/Components/Modals/CustomerOnHoldWarningModal";

const ClientQuotations: React.FC<{
  clientId: string;
}> = ({ clientId }) => {
  const USER_PERMISSIONS = usePermissionsChecker(
    PagePermissionNameData.QUOTATIONS,
  );
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [quotationsList, setQuotationsList] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);
  const [limit] = useState<number>(15);
  const [search, setSearch] = useState<string>("");
  const debouncedSearch = useDebounce(search, 500);
  const [hasMore, setHasMore] = useState(true);
  const [startDate, setStartDate] = useState<any>("");
  const [endDate, setEndDate] = useState<any>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [isAdminApprovalOn, setIsAdminApprovalOn] = useState<boolean>(false);

  const [failedAddressData, setFailedAddressData] = useState<any>(null);
  const [drawingRequiredData, setDrawingRequiredData] = useState<any>(null);

  const abortControllerRef = useRef<AbortController | null>(null);

  const [sorterState, setSorterState] = useState<{
    field: string | null;
    order: "ascend" | "descend" | null;
  }>({
    field: null,
    order: null,
  });

  // --- Delete Modal ---
  const [idToDelete, setIdToDelete] = useState<string | null>(null);
  const [deleting, setDeleting] = useState(false);
  const [idToOverride, setIdToOverride] = useState<string | null>(null);
  const [idToDuplicate, setIdToDuplicate] = useState<string | null>(null);
  const [isDuplicating, setIsDuplicating] = useState<boolean>(false);

  const [idToCreateRevision, setIdToCreateRevision] = useState<string | null>(
    null,
  );
  const [isCreatingRevision, setIsCreatingRevision] = useState<boolean>(false);

  const [idToNotify, setIdToNotify] = useState<string | null>(null);
  const [isNotifying, setIsNotifying] = useState(false);

  const [apiWarnings, setApiWarnings] = useState<any[]>([]);
  const [apiWarningSeverity, setApiWarningSeverity] = useState<
    WarningSeverity | ""
  >("");
  const [pendingStatusData, setPendingStatusData] = useState<any>(null);
  const [pendingNotifyId, setPendingNotifyId] = useState<string | null>(null);

  const [submittingCreateOrder, setSubmittingCreateOrder] = useState(false);
  const [selectedQuoteData, setSelectedQuoteData] = useState<any>(null);
  const [isCreateOrder, setIsCreateOrder] = useState(false);

  const [exporting, setExporting] = useState(false);

  const user = getDecryptedUserData();
  const userId = user?._id || "";
  const alias = useAppSelector((state: any) => state.auth.alias);
  const messageCloserRef = useRef<any>(null);
  const scrollableDivRef = useRef<HTMLDivElement>(null);

  const [idToReopen, setIdToReopen] = useState<string | null>(null);
  const [isReopening, setIsReopening] = useState(false);

  const [idToAdminApprove, setIdToAdminApprove] = useState<string | null>(null);
  const [isAdminApproving, setIsAdminApproving] = useState<boolean>(false);
  const [idToDownloadAndMarkSent, setIdToDownloadAndMarkSent] = useState<
    string | null
  >(null);
  const [isDownloadingAndMarkingSent, setIsDownloadingAndMarkingSent] =
    useState<boolean>(false);
  const [pendingApprovalCustomerId, setPendingApprovalCustomerId] = useState<
    string | null
  >(null);

  const [isChangingStatus, setIsChangingStatus] = useState(false);

  const [profitData, setProfitData] = useState<any>(null);
  const [profitModal, setProfitModal] = useState(false);

  const [customerOnHoldModal, setCustomerOnHoldModal] = useState(false);
  const [customerOnHoldMessage, setCustomerOnHoldMessage] = useState("");

  const changeStatusHandler = (
    status:
      | "saved"
      | "sent"
      | "design_pending"
      | "design_approved"
      | "admin_approved",
    quotationId: string,
    forceUpdate: boolean = false,
    options?: {
      onSuccess?: () => void;
      onError?: () => void;
      onFinally?: () => void;
    },
  ) => {
    setIsChangingStatus(true);
    const payload = {
      quote_id: quotationId,
      status: status,
      force_update: forceUpdate,
    };
    dispatch(
      updateQuotatioStatusAPI({
        payload,
        onSuccess: (data: any) => {
          setIsChangingStatus(false);
          setQuotationsList((prev) =>
            prev.map((quote) =>
              quote._id === quotationId
                ? { ...quote, status: data.status }
                : quote,
            ),
          );
          setPendingStatusData(null);
          setApiWarnings([]);
          setApiWarningSeverity("");
          options?.onSuccess?.();
          options?.onFinally?.();
        },
        onWarnings: (warnings: any, severity: any) => {
          setIsChangingStatus(false);
          setApiWarnings(warnings);
          setApiWarningSeverity(severity || "");
          setPendingStatusData({ status, quotationId });
          options?.onFinally?.();
        },
        onError: () => {
          setIsChangingStatus(false);
          options?.onError?.();
          options?.onFinally?.();
        },
      }),
    );
  };

  const onCellClick = (record: any) => ({
    onClick: () => {
      // ✅ Read Guard
      if (USER_PERMISSIONS.READ) {
        navigate(`/quotations/${record._id}?tab=customer-details`, {
          state: {
            backPath: `/clients-distributors/${clientId}`,
            backTabPath: "Quotations",
          },
        });
      }
    },
    style: { cursor: USER_PERMISSIONS.READ ? "pointer" : "default" },
  });

  const fetchQuotationsData = (page: number, isReset: boolean) => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;
    if (isReset) {
      setLoading(true);
    }
    const filters = {
      page: page,
      limit: limit,
      search: debouncedSearch,
      date_from: startDate,
      date_to: endDate,
      sortBy: sorterState.field,
      sortOrder: sorterState.order,
      // status: statusFilter,
      customer_id: [clientId as string],
      is_archived: "false",
      // created_by: [createdByFilter as string],
    };

    dispatch(
      getQuotationsListAPI({
        filters,
        signal: controller.signal,
        onSuccess: (data: any) => {
          const newData = data?.quotes || [];
          const total = data?.total || 0;
          setTotalCount(total);
          setIsAdminApprovalOn(data?.admin_approval_required ?? false);

          if (isReset) {
            setQuotationsList(newData);
          } else {
            setQuotationsList((prev) => [...prev, ...newData]);
          }

          const currentCount = isReset
            ? newData.length
            : quotationsList.length + newData.length;
          setHasMore(currentCount < total);
          setLoading(false);
        },
        onError: () => {
          setLoading(false);
        },
      }),
    );
  };

  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  useEffect(() => {
    setPage(1);
    setHasMore(true);
    fetchQuotationsData(1, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    debouncedSearch,
    startDate,
    endDate,
    sorterState,
    // statusFilter,
    // companyFilter,
    // createdByFilter,
  ]);

  const MoreOptionsMenu = (data: any) => {
    const isCreatedForSelf = userId === data?.customer_id?._id;
    const isClientViewingOwnQuote = isCustomerLoggedIn() && isCreatedForSelf;
    const isClientViewingOtherUserQuote =
      isCustomerLoggedIn() && !isCreatedForSelf;

    if (isClientViewingOwnQuote) {
      return (
        <Menu>
          {data?.status === QuoteStatus.DRAFT && (
            <>
              {USER_PERMISSIONS.MODIFY && (
                <Menu.Item
                  key="1"
                  onClick={() => {
                    sessionStorage.removeItem(QUOTATION_SCROLL_KEY);
                    sessionStorage.removeItem(QUOTATION_FILTER_KEY);
                    sessionStorage.setItem(QUOTATION_REFETCH_KEY, "1");
                    navigate(
                      `/quotations/create-quotation?step=${CreateQuotationStepsEnum.CUSTOMER_DETAILS}&quotationId=${data._id}&mode=edit`,
                      {
                        state: {
                          backPath: `/clients-distributors/${clientId}`,
                          backTabPath: "Quotations",
                        },
                      },
                    );
                  }}
                >
                  <div className="text-black d-flex align-items-center gap-2 svg-20">
                    Modify
                  </div>
                </Menu.Item>
              )}
              {USER_PERMISSIONS.REMOVE && (
                <Menu.Item key="3" onClick={() => setIdToDelete(data._id)}>
                  <div className="text-danger d-flex align-items-center gap-2 svg-20">
                    Remove
                  </div>
                </Menu.Item>
              )}
            </>
          )}
          {USER_PERMISSIONS.READ &&
            data?.status !== QuoteStatus.DRAFT &&
            data?.status !== QuoteStatus.EXPIRED && (
              <Menu.Item
                key="quotation_pdf"
                onClick={() => {
                  if (exporting) return;
                  const closeMessage = message.loading(
                    "Generating PDF, please wait...",
                    0,
                  );
                  messageCloserRef.current = closeMessage;
                  setExporting(true);
                  dispatch(
                    generateQuotationPdfAPI({
                      payload: { quote_id: data._id },
                      onSuccess: () => {
                        closeMessage();
                        setExporting(false);
                        messageCloserRef.current = null;
                      },
                      onError: () => {
                        closeMessage();
                        setExporting(false);
                        messageCloserRef.current = null;
                      },
                    }),
                  );
                }}
              >
                Quotation PDF
              </Menu.Item>
            )}
        </Menu>
      );
    }

    if (isClientViewingOtherUserQuote) {
      return (
        <Menu>
          {USER_PERMISSIONS.READ && data?.status !== QuoteStatus.EXPIRED && (
            <Menu.Item
              key="quotation_pdf"
              onClick={() => {
                if (exporting) return;
                const closeMessage = message.loading(
                  "Generating PDF, please wait...",
                  0,
                );
                messageCloserRef.current = closeMessage;
                setExporting(true);
                dispatch(
                  generateQuotationPdfAPI({
                    payload: { quote_id: data._id },
                    onSuccess: () => {
                      closeMessage();
                      setExporting(false);
                      messageCloserRef.current = null;
                    },
                    onError: () => {
                      closeMessage();
                      setExporting(false);
                      messageCloserRef.current = null;
                    },
                  }),
                );
              }}
            >
              Quotation PDF
            </Menu.Item>
          )}
        </Menu>
      );
    }

    return (
      <Menu>
        {/* ✅ Add/Modify Guard (Create Order) */}
        {USER_PERMISSIONS.ADD &&
          [
            QuoteStatus.SAVED,
            QuoteStatus.SENT,
            QuoteStatus.ADMIN_APPROVED,
            QuoteStatus.APPROVED,
            QuoteStatus.APPROVED_OVERRIDE,
          ].includes(data?.status) && (
            <Menu.Item
              key="create-order"
              onClick={() => {
                setSelectedQuoteData(data);
                setIsCreateOrder(true);
              }}
            >
              Create Order
            </Menu.Item>
          )}
        {USER_PERMISSIONS.MODIFY &&
          [QuoteStatus.EXPIRED].includes(data?.status) && (
            <Menu.Item
              key="re-open"
              onClick={() => {
                setIdToReopen(data._id);
              }}
            >
              Re-Open
            </Menu.Item>
          )}
        {USER_PERMISSIONS.MODIFY &&
          (isAdminSubAdminLoggedIn() || !isAdminApprovalOn
            ? data?.is_design === false ||
              ![QuoteStatus.DRAFT, QuoteStatus.DESIGN_PENDING].includes(
                data?.status,
              )
            : (data?.is_design === false ||
                ![QuoteStatus.DRAFT, QuoteStatus.DESIGN_PENDING].includes(
                  data?.status,
                )) &&
              ![
                QuoteStatus.DRAFT,
                QuoteStatus.DESIGN_APPROVED,
                QuoteStatus.PENDING_ADMIN_APPROVAL,
              ].includes(data?.status)) && (
            <>
              {/* <Menu.Item
                key="save"
                onClick={() => {
                  changeStatusHandler("saved", data._id);
                }}
              >
                Save
              </Menu.Item> */}
              <Menu.Item
                key="save&send"
                onClick={() => {
                  changeStatusHandler("sent", data._id);
                }}
              >
                Email & Mark Sent
              </Menu.Item>
            </>
          )}

        {!isCustomerLoggedIn() &&
          isAdminSubAdminLoggedIn() &&
          isAdminApprovalOn &&
          [QuoteStatus.DRAFT, QuoteStatus.PENDING_ADMIN_APPROVAL].includes(
            data?.status,
          ) && (
            <Menu.Item
              key="mark_admin_approved"
              onClick={() => {
                if (data?.customer_snapshot?.is_approved === false) {
                  const custId =
                    typeof data?.customer_id === "object"
                      ? data?.customer_id?._id
                      : data?.customer_id;
                  setPendingApprovalCustomerId(custId || null);
                } else {
                  setIdToAdminApprove(data._id);
                }
              }}
            >
              Mark Admin Approved
            </Menu.Item>
          )}

        {/* {USER_PERMISSIONS.READ &&
          [QuoteStatus.SAVED, QuoteStatus.SENT].includes(data?.status) && (
            <Menu.Item
              key="share_approval_link"
              onClick={async () => {
                // 1. Get the base (http://localhost:3000/sm-crm)
                // window.location.origin handles the protocol and port automatically
                const baseUrl = alias
                  ? `${window.location.origin}/${alias}`
                  : window.location.origin;

                // 2. Get the dynamic ID (assuming 'id' is the property in your data object)
                const id = data._id;
                if (!id) {
                  console.error("No quotation ID found in data.");
                  return;
                }

                // 3. Construct the full URL
                let fullUrl = `${baseUrl}/quotation-details/${id}`;

                if (Capacitor.isNativePlatform()) {
                  fullUrl = getCapacitorBaseUrl(fullUrl);
                }

                try {
                  // 4. Copy to clipboard
                  await navigator.clipboard.writeText(fullUrl);
                  message.success("Approval link copied to clipboard!");
                  // Optional: Add your UI notification here (e.g., message.success)
                  console.log("Copied:", fullUrl);
                } catch (err) {
                  console.error("Failed to copy URL:", err);
                }
              }}
            >
              Share Approval Link
            </Menu.Item>
          )} */}

        {/* ✅ Modify Guard (Approval Override) */}
        {/* {!isCustomerLoggedIn() &&
          USER_PERMISSIONS.MODIFY &&
          [QuoteStatus.SAVED, QuoteStatus.SENT].includes(data?.status) && (
            <Menu.Item
              key="approval_override"
              onClick={() => setIdToOverride(data._id)}
              style={{ color: "#52c41a" }}
            >
              Approval Override
            </Menu.Item>
          )} */}

        {/* ✅ Modify Guard (Notify Client) */}
        {!isCustomerLoggedIn() &&
          USER_PERMISSIONS.MODIFY &&
          [
            QuoteStatus.SAVED,
            QuoteStatus.SENT,
            QuoteStatus.APPROVED,
            QuoteStatus.APPROVED_OVERRIDE,
          ].includes(data?.status) && (
            <Menu.Item
              key="notify_cleint"
              onClick={() => {
                setIdToNotify(data._id);
                const payload = { quote_id: data._id };
                dispatch(
                  notifyClientAPI({
                    payload,
                    onSuccess: () => {},
                    onWarnings: (warnings: any, severity: any) => {
                      setApiWarnings(warnings);
                      setApiWarningSeverity(severity || "");
                      setPendingNotifyId(data._id);
                    },
                    onError: () => {},
                  }),
                );
              }}
            >
              Notify to Client
            </Menu.Item>
          )}

        {/* ✅ Read Guard (PDF Generation/Export) */}
        {USER_PERMISSIONS.READ &&
          [
            QuoteStatus.SAVED,
            QuoteStatus.SENT,
            QuoteStatus.APPROVED,
            QuoteStatus.APPROVED_OVERRIDE,
            QuoteStatus.ORDER_CREATED,
          ].includes(data?.status) && (
            <Menu.Item
              key="quotation_pdf"
              onClick={() => {
                if (exporting) return;
                const closeMessage = message.loading(
                  "Generating PDF, please wait...",
                  0,
                );
                messageCloserRef.current = closeMessage;
                setExporting(true);
                dispatch(
                  generateQuotationPdfAPI({
                    payload: { quote_id: data._id },
                    onSuccess: () => {
                      closeMessage();
                      setExporting(false);
                      messageCloserRef.current = null;
                    },
                    onError: () => {
                      closeMessage();
                      setExporting(false);
                      messageCloserRef.current = null;
                    },
                  }),
                );
              }}
            >
              Quotation PDF
            </Menu.Item>
          )}

        {/* Download & Mark Sent (Admin Approved only) */}
        {USER_PERMISSIONS.MODIFY &&
          data?.status === QuoteStatus.ADMIN_APPROVED && (
            <Menu.Item
              key="download_and_mark_sent"
              onClick={() => {
                setIdToDownloadAndMarkSent(data._id);
              }}
            >
              Download & Mark Sent
            </Menu.Item>
          )}

        {/* ✅ Modify Guard (Edit Quotation) */}
        {USER_PERMISSIONS.MODIFY &&
          ![
            QuoteStatus.APPROVED,
            QuoteStatus.APPROVED_OVERRIDE,
            QuoteStatus.EXPIRED,
            QuoteStatus.ORDER_CREATED,
          ].includes(data.status) && (
            <Menu.Item
              key="1"
              onClick={() => {
                sessionStorage.removeItem(QUOTATION_SCROLL_KEY);
                sessionStorage.removeItem(QUOTATION_FILTER_KEY);
                sessionStorage.setItem(QUOTATION_REFETCH_KEY, "1");
                navigate(
                  `/quotations/create-quotation?step=${CreateQuotationStepsEnum.CUSTOMER_DETAILS}&quotationId=${data._id}&mode=edit`,
                  {
                    state: {
                      backPath: `/clients-distributors/${clientId}`,
                      backTabPath: "Quotations",
                    },
                  },
                );
              }}
            >
              <div className="text-black d-flex align-items-center gap-2 svg-20">
                Modify
              </div>
            </Menu.Item>
          )}

        {USER_PERMISSIONS.MODIFY && (
          <>
            <Menu.Item
              key="duplicate"
              onClick={() => {
                setIdToDuplicate(data._id);
              }}
            >
              <div className="text-black d-flex align-items-center gap-2 svg-20">
                Duplicate
              </div>
            </Menu.Item>
            <Menu.Item
              key="create-revision"
              onClick={() => {
                setIdToCreateRevision(data._id);
              }}
            >
              <div className="text-black d-flex align-items-center gap-2 svg-20">
                Create Revision
              </div>
            </Menu.Item>
          </>
        )}

        {!isCustomerLoggedIn() && USER_PERMISSIONS.READ && (
          <Menu.Item
            key="2"
            onClick={() => {
              if (scrollableDivRef.current) {
                sessionStorage.setItem(
                  QUOTATION_SCROLL_KEY,
                  String(scrollableDivRef.current.scrollTop),
                );
              }
              navigate(`/quotations/${data._id}/audit-log`, {
                state: {
                  backPath: `/clients-distributors/${clientId}`,
                  backTabPath: "Quotations",
                },
              });
            }}
          >
            <div className="text-black d-flex align-items-center gap-2 svg-20">
              Audit Log
            </div>
          </Menu.Item>
        )}

        {/* ✅ Remove Guard */}
        {USER_PERMISSIONS.REMOVE &&
          ![
            QuoteStatus.APPROVED,
            QuoteStatus.APPROVED_OVERRIDE,
            QuoteStatus.ORDER_CREATED,
          ].includes(data?.status) && (
            <Menu.Item key="3" onClick={() => setIdToDelete(data._id)}>
              <div className="text-danger d-flex align-items-center gap-2 svg-20">
                Remove
              </div>
            </Menu.Item>
          )}
      </Menu>
    );
  };

  const columns: TableColumnsType<any> = [
    {
      title: "Quote ID",
      dataIndex: "display_quote_id",
      key: "display_quote_id",
      sorter: true,
      sortOrder:
        sorterState.field === "display_quote_id" ? sorterState.order : null,
      onCell: onCellClick,
      render: (display_quote_id: any, record: any) =>
        display_quote_id ? display_quote_id : "-",
    },
    {
      title: "Company Name",
      dataIndex: ["customer_id", "company_name"],
      key: "company_name",
      sorter: true,
      sortOrder:
        sorterState.field === "company_name" ? sorterState.order : null,
      onCell: onCellClick,
      render: (val: any) => (val ? val : "-"),
    },
    {
      title: "Email",
      dataIndex: ["customer_snapshot", "email"],
      key: "email",
      sorter: true,
      sortOrder: sorterState.field === "email" ? sorterState.order : null,
      onCell: onCellClick,
      render: (email: any) => (email ? email : "-"),
    },
    {
      title: "Phone",
      dataIndex: ["customer_snapshot", "phone"],
      key: "phone",
      sorter: true,
      sortOrder: sorterState.field === "phone" ? sorterState.order : null,
      onCell: onCellClick,
      render: (phone: any) => (phone ? phone : "-"),
    },
    {
      title: "Amount",
      dataIndex: "grand_total",
      key: "grand_total",
      sorter: true,
      sortOrder: sorterState.field === "grand_total" ? sorterState.order : null,
      onCell: onCellClick,
      render: (amount: any, record: any) => (
        <span className="fw-bold">
          {formatCurrency(
            amount,
            record?.currency || "GBP",
            record?.conversion_rate || 1,
          )}
        </span>
      ),
    },
    ...([ROLE.ADMIN, ROLE.SUB_ADMIN].includes(user?.role?.key)
      ? [
          {
            title: "Estimated Profit",
            dataIndex: "estimated_profit",
            key: "estimated_profit",
            sorter: true,
            sortOrder:
              sorterState.field === "estimated_profit"
                ? sorterState.order
                : null,
            render: (_: any, record: any) => {
              const profit_data = record?.profit_data;
              const profit = profit_data?.estimated_profit || 0;
              return (
                <div
                  className="cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    setProfitData({
                      ...profit_data,
                      display_quote_id: record?.display_quote_id,
                      vat_percentages: record?.vat_percentage,
                      conversion_rate: record?.conversion_rate,
                      currency: record?.currency,
                    });
                    setProfitModal(true);
                  }}
                >
                  {profit > 0 ? (
                    <span className="text-success fw-semibold">
                      {formatCurrency(
                        Number(profit) || 0,
                        record?.currency,
                        record?.conversion_rate,
                      )}
                    </span>
                  ) : profit < 0 ? (
                    <span className="text-danger fw-semibold">
                      {formatCurrency(
                        Number(Math.abs(profit)) || 0,
                        record?.currency,
                        record?.conversion_rate,
                      )}
                    </span>
                  ) : (
                    formatCurrency(
                      Number(0) || 0,
                      record?.currency,
                      record?.conversion_rate,
                    )
                  )}
                </div>
              );
            },
          },
          {
            title: "Actual Profit",
            dataIndex: "total_profit",
            key: "total_profit",
            sorter: true,
            sortOrder:
              sorterState.field === "total_profit" ? sorterState.order : null,
            render: (_: any, record: any) => {
              const profit_data = record?.profit_data;
              const profit = profit_data?.total_profit || 0;
              return !profit_data?.is_order_created ? (
                <Tooltip
                  title={
                    "The actual profit calculation will be shown after the order is invoiced."
                  }
                >
                  <div className="d-flex justify-content-center">-</div>
                </Tooltip>
              ) : (
                <div
                  className="cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    setProfitData({
                      ...profit_data,
                      display_quote_id: record?.display_quote_id,
                      vat_percentages: record?.vat_percentage,
                      conversion_rate: record?.conversion_rate,
                      currency: record?.currency,
                    });
                    setProfitModal(true);
                  }}
                >
                  {profit > 0 ? (
                    <span className="text-success fw-semibold">
                      {formatCurrency(
                        Number(profit) || 0,
                        record?.currency,
                        record?.conversion_rate,
                      )}
                    </span>
                  ) : profit < 0 ? (
                    <span className="text-danger fw-semibold">
                      {formatCurrency(
                        Number(Math.abs(profit)) || 0,
                        record?.currency,
                        record?.conversion_rate,
                      )}
                    </span>
                  ) : (
                    formatCurrency(
                      Number(0) || 0,
                      record?.currency,
                      record?.conversion_rate,
                    )
                  )}
                </div>
              );
            },
          },
        ]
      : []),
    {
      title: "Estimated Lead Time",
      dataIndex: "estimated_lead_time",
      key: "estimated_lead_time",
      width: 140,
      onCell: onCellClick,
      render: (_: any, record: any) => {
        const estimatedLeadTimeDays = record?.estimated_lead_time;
        if (estimatedLeadTimeDays == null) {
          return <span>-</span>;
        }
        const estimatedLeadTimeWeeks = Number(
          (estimatedLeadTimeDays / 7).toFixed(1),
        );
        return (
          <span className="fw-semibold text-primary">
            {estimatedLeadTimeWeeks.toFixed(1)}{" "}
            {estimatedLeadTimeWeeks === 1 ? "Week" : "Weeks"}
          </span>
        );
      },
    },
    {
      title: "Created By",
      dataIndex: "created_by",
      key: "created_by",
      sorter: true, // Assuming backend supports sorting by creator
      sortOrder: sorterState.field === "created_by" ? sorterState.order : null,
      onCell: onCellClick,
      render: (user: any) => {
        if (user && typeof user === "object") {
          return (
            <span>
              {getDecryptedName(user)}
              {user?.role?.name ? `(${user?.role?.name})` : "-"}
            </span>
          );
        }
        return "-";
      },
    },
    {
      title: "Created On",
      dataIndex: "created_at",
      key: "created_at",
      sorter: true,
      sortOrder: sorterState.field === "created_at" ? sorterState.order : null,
      onCell: onCellClick,
      render: (createdAt: any) =>
        createdAt ? formatToLocalDate(createdAt, true) : "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: true,
      sortOrder: sorterState.field === "status" ? sorterState.order : null,
      onCell: onCellClick,
      render: (status: any) => {
        const displayLabel = QuoteStatusLabels[status as QuoteStatus] || status;
        return (
          <span
            className={
              "d-inline-flex align-items-center billStatus " +
              statusFindClass(status)
            }
          >
            {svg.dotIcon}
            {displayLabel}
          </span>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div className="d-flex" onClick={(e) => e.stopPropagation()}>
          {(USER_PERMISSIONS.READ ||
            USER_PERMISSIONS.MODIFY ||
            USER_PERMISSIONS.REMOVE) && (
            <Dropdown
              overlay={() => MoreOptionsMenu(record)}
              trigger={["click"]}
              placement="bottomRight"
              className="cursor-pointer"
              overlayClassName="moreOptionDropdown"
            >
              <span className="svg-28 svg-outline-primary">
                {svg?.tableMoreOption}
              </span>
            </Dropdown>
          )}
        </div>
      ),
    },
  ];

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    if (sorter.order) {
      setSorterState({ field: sorter.columnKey, order: sorter.order });
    } else {
      setSorterState({ field: null, order: null });
    }
    setPage(1);
  };

  const searchBarClean = () => {
    setSearch("");
  };

  const searchBarHandler = (e: any) => {
    setSearch(e.target.value);
  };

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchQuotationsData(nextPage, false);
  };

  const handleDeleteConfirm = () => {
    if (!idToDelete) return;
    setDeleting(true);
    dispatch(
      deleteQuotationAPI({
        id: idToDelete,
        onSuccess: () => {
          setDeleting(false);
          setQuotationsList((prev) => prev.filter((q) => q._id !== idToDelete));
          setTotalCount((prev) => prev - 1);
          setIdToDelete(null);
        },
        onError: () => setDeleting(false),
      }),
    );
  };
  return (
    <>
      <div className="h-100">
        <div className="mb-md-3 mb-2 d-flex flex-column gap-md-2 gap-0">
          <div className="d-flex flex-md-nowrap flex-wrap gap-md-3 gap-2 justify-content-between align-items-center">
            <h2 className="text-black fs-36 fw-bolder page-title mb-0 order-sm-1 order-1">
              Quotations
              <span>
                {page === 1 && loading
                  ? ""
                  : totalCount
                  ? `(${totalCount})`
                  : ""}
              </span>
            </h2>
            <div
              className={`d-flex flex-md-nowrap flex-wrap gap-sm-3 gap-2 justify-content-end align-items-center ms-auto order-sm-2 order-3 mobileFilter`}
            >
              <div
                className={`pageSearch mw-100 position-relative d-inline-block mt-sm-0 mt-2`}
              >
                <input
                  type="text"
                  value={search}
                  className="form-control form-control-lg"
                  onChange={searchBarHandler}
                  placeholder="Search"
                />
                {search?.length ? (
                  <span className="cursor-pointer" onClick={searchBarClean}>
                    {svg?.searchClear}
                  </span>
                ) : (
                  <span>{svg?.search}</span>
                )}
              </div>
            </div>
            {USER_PERMISSIONS.ADD && (
              <div className="d-md-flex justify-content-end align-items-center order-sm-3 order-2">
                <button
                  className="btn btn-lg btn-primary mob-btn"
                  onClick={() => {
                    navigate(
                      `/quotations/create-quotation?step=${CreateQuotationStepsEnum.CUSTOMER_DETAILS}&customerId=${clientId}`,
                    );
                  }}
                >
                  + CREATE
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="card page-table-card border-0 shadow rounded-4 flex-fill overflow-y-auto">
          <div className="card-body overflow-y-auto" id="mainScrollDiv">
            {loading && page === 1 ? (
              <FullScreenLoader />
            ) : quotationsList?.length === 0 ? (
              <NoDataMessage
                icon={svg?.noQuotationIcon}
                text="You do not have any quotations yet."
              />
            ) : (
              <InfiniteScroll
                dataLength={quotationsList.length}
                next={handleLoadMore}
                hasMore={hasMore}
                loader={
                  <div className="text-center p-2">
                    <Spin />
                  </div>
                }
                scrollableTarget="mainScrollDiv"
              >
                <Table
                  dataSource={quotationsList}
                  scroll={{ x: "max-content" }}
                  pagination={false}
                  columns={columns}
                  onChange={handleTableChange}
                  rowKey={(record) => record._id}
                  className="custom-table"
                  bordered
                  rowClassName={(record) => {
                    const creatorRole = record.created_by?.role?.key;

                    const isCreatedByClient = [
                      RoleTypesEnum.CLIENT,
                      RoleTypesEnum.DISTRIBUTOR,
                    ].includes(creatorRole);

                    if (isCreatedByClient) {
                      return "border-external-user";
                    } else {
                      return "border-sm-team";
                    }
                  }}
                />
              </InfiniteScroll>
            )}
          </div>
        </div>
      </div>
      <CommonConfirmationModal
        open={idToDelete != null}
        title="Delete Quotation?"
        subTitle="Are you sure you want to delete this quotation? This action cannot be undone."
        loading={deleting}
        onSuccess={handleDeleteConfirm}
        onClose={() => setIdToDelete(null)}
        confirmButtonText="Delete"
      />

      {idToOverride !== null && (
        <AddApprovalOverrideNoteModal
          open={idToOverride != null}
          onClose={() => setIdToOverride(null)}
          quote_id={idToOverride}
          refreshData={(data: any) => {
            setQuotationsList((prev) =>
              prev.map((quote) =>
                quote._id === data._id
                  ? { ...quote, status: data.status }
                  : quote,
              ),
            );
          }}
        />
      )}

      <CommonConfirmationModal
        open={idToReopen != null}
        onClose={() => setIdToReopen(null)}
        onSuccess={() => {
          setIsReopening(true);
          const payload = {
            quote_id: idToReopen,
          };
          dispatch(
            reopenQuotationAPI({
              payload,
              onSuccess: (data: any) => {
                setQuotationsList((prev) =>
                  prev.map((quote) =>
                    quote._id === data._id
                      ? { ...quote, status: data.status }
                      : quote,
                  ),
                );
                setIsReopening(false);
                setIdToReopen(null);
              },
              onError: () => {
                setIsReopening(false);
              },
            }),
          );
        }}
        title="Re-Open Quotation, Are You Sure?"
        subTitle={`Reopening this quotation will change its status to "Draft." Any previously completed approvals may need to be completed again. Are you sure you want to continue?`}
        confirmButtonColorClass="btn-primary"
        confirmButtonText="Proceed"
        loading={isReopening}
      />

      <CommonConfirmationModal
        open={idToDuplicate != null}
        onClose={() => setIdToDuplicate(null)}
        onSuccess={() => {
          setIsDuplicating(true);
          const payload = {
            quote_id: idToDuplicate,
          };
          dispatch(
            duplicateQuotationAPI({
              payload,
              onSuccess: (data: any) => {
                sessionStorage.removeItem(QUOTATION_SCROLL_KEY);
                sessionStorage.removeItem(QUOTATION_FILTER_KEY);
                sessionStorage.setItem(QUOTATION_REFETCH_KEY, "1");
                setIsDuplicating(false);
                setIdToDuplicate(null);
                // Also trigger reload
                fetchQuotationsData(1, true);
              },
              onError: () => {
                setIsDuplicating(false);
              },
            }),
          );
        }}
        title="Duplicate Quotation, Are You Sure?"
        subTitle="This action will create a copy of the selected quotation with the same details in the Draft stage. You can modify the duplicated quotation as needed."
        confirmButtonColorClass="btn-primary"
        confirmButtonText="Duplicate"
        loading={isDuplicating}
      />

      <CommonConfirmationModal
        open={idToCreateRevision != null}
        onClose={() => setIdToCreateRevision(null)}
        onSuccess={() => {
          setIsCreatingRevision(true);
          const payload = {
            quote_id: idToCreateRevision,
          };
          dispatch(
            createRevisionQuotationAPI({
              payload,
              onSuccess: (data: any) => {
                sessionStorage.removeItem(QUOTATION_SCROLL_KEY);
                sessionStorage.removeItem(QUOTATION_FILTER_KEY);
                sessionStorage.setItem(QUOTATION_REFETCH_KEY, "1");
                setIsCreatingRevision(false);
                setIdToCreateRevision(null);
                // Also trigger reload
                fetchQuotationsData(1, true);
              },
              onError: () => {
                setIsCreatingRevision(false);
              },
            }),
          );
        }}
        title="Create Revision, Are You Sure?"
        subTitle="Creating a revision will generate a new version of this record. The current version will be preserved. Do you want to continue?"
        confirmButtonColorClass="btn-primary"
        confirmButtonText="Create Revision"
        loading={isCreatingRevision}
      />

      <CommonConfirmationModal
        open={idToAdminApprove != null}
        onClose={() => {
          if (!isAdminApproving) {
            setIdToAdminApprove(null);
          }
        }}
        onSuccess={() => {
          if (idToAdminApprove) {
            setIsAdminApproving(true);
            changeStatusHandler("admin_approved", idToAdminApprove, false, {
              onSuccess: () => {
                setIdToAdminApprove(null);
              },
              onFinally: () => {
                setIsAdminApproving(false);
              },
            });
          }
        }}
        title="Mark This Quotation as Admin Approved?"
        subTitle="Are you sure you want to mark this quotation as Admin Approved? This will update the quotation's approval status and allow it to proceed to the next stage of the workflow."
        confirmButtonColorClass="btn-primary"
        confirmButtonText="Approve"
        loading={isAdminApproving}
      />

      <CommonConfirmationModal
        open={idToDownloadAndMarkSent != null}
        onClose={() => {
          if (!isDownloadingAndMarkingSent) {
            setIdToDownloadAndMarkSent(null);
          }
        }}
        onSuccess={() => {
          if (idToDownloadAndMarkSent) {
            const targetQuoteId = idToDownloadAndMarkSent;
            setIsDownloadingAndMarkingSent(true);
            const closeLoadingMsg = message.loading(
              "Generating PDF and updating status...",
              0,
            );

            // Step 1: Generate & download PDF
            dispatch(
              generateQuotationPdfAPI({
                payload: { quote_id: targetQuoteId },
                onSuccess: () => {
                  // Step 2: On PDF success, update status to 'sent'
                  changeStatusHandler("sent", targetQuoteId, false, {
                    onSuccess: () => {
                      closeLoadingMsg();
                      setIsDownloadingAndMarkingSent(false);
                      setIdToDownloadAndMarkSent(null);
                    },
                    onError: () => {
                      closeLoadingMsg();
                      setIsDownloadingAndMarkingSent(false);
                      message.warning(
                        "Quotation PDF downloaded, but failed to update status to Sent. Please try again.",
                      );
                    },
                  });
                },
                onError: () => {
                  closeLoadingMsg();
                  setIsDownloadingAndMarkingSent(false);
                  message.error(
                    "Failed to generate Quotation PDF. Status was not changed.",
                  );
                },
              }),
            );
          }
        }}
        title="Download & Mark as Sent?"
        subTitle="Are you sure you want to download this Quotation PDF & change status as Sent?"
        confirmButtonColorClass="btn-primary"
        confirmButtonText="Proceed"
        loading={isDownloadingAndMarkingSent}
      />

      <CommonConfirmationModal
        open={pendingApprovalCustomerId != null}
        onClose={() => setPendingApprovalCustomerId(null)}
        onSuccess={() => {
          const custId = pendingApprovalCustomerId;
          setPendingApprovalCustomerId(null);
          if (custId) {
            navigate(`/clients-distributors/${custId}`);
          }
        }}
        title="Customer Approval Required"
        subTitle="This customer has not been approved yet. Please review and approve the customer details before approving this quotation."
        confirmButtonColorClass="btn-primary"
        confirmButtonText="View Customer Details"
      />

      <WarningsModal
        warnings={apiWarnings}
        onClose={() => {
          setApiWarnings([]);
          setApiWarningSeverity("");
          setPendingNotifyId(null);
          setPendingStatusData(null);
        }}
        actions={
          apiWarningSeverity === WarningSeverity.BLOCKING
            ? WarningActionLayouts.Blocking(() => {
                setApiWarnings([]);
                setApiWarningSeverity("");
                setPendingNotifyId(null);
                setPendingStatusData(null);
              })
            : WarningActionLayouts.BypassableSave(
                () => {
                  setApiWarnings([]);
                  setApiWarningSeverity("");
                  setPendingNotifyId(null);
                  setPendingStatusData(null);
                },
                () => {
                  if (pendingNotifyId) {
                    setIsNotifying(true);
                    const payload = {
                      quote_id: pendingNotifyId,
                      force_update: true,
                    };
                    dispatch(
                      notifyClientAPI({
                        payload,
                        onSuccess: () => {
                          setIsNotifying(false);
                          setPendingNotifyId(null);
                          setApiWarnings([]);
                          setApiWarningSeverity("");
                        },
                        onWarnings: (warnings: any, severity: any) => {
                          setIsNotifying(false);
                          setApiWarnings(warnings);
                          setApiWarningSeverity(severity || "");
                        },
                        onError: () => {
                          setIsNotifying(false);
                        },
                      }),
                    );
                  } else if (pendingStatusData) {
                    changeStatusHandler(
                      pendingStatusData.status,
                      pendingStatusData.quotationId,
                      true,
                    );
                  }
                },
                isNotifying || isChangingStatus,
              )
        }
      />

      {isCreateOrder && (
        <CreateOrderConfirmationModal
          open={isCreateOrder}
          onClose={() => setIsCreateOrder(false)}
          onSuccess={() => {
            setSubmittingCreateOrder(true);
            dispatch(
              createOrderAPI({
                payload: { quote_id: selectedQuoteData?._id },
                onSuccess: (resData) => {
                  setSubmittingCreateOrder(false);
                  navigate(`/orders/${resData?._id}`);
                  setIsCreateOrder(false);
                },
                onError: () => {
                  setSubmittingCreateOrder(false);
                },
                onAddressIncompleteError: (errData) => {
                  setIsCreateOrder(false);
                  setFailedAddressData(errData?.data);
                },
                onDrawingRequiredError: (data) => {
                  setIsCreateOrder(false);
                  setDrawingRequiredData(data?.data || {});
                },
                onCustomerOnHoldError: (data: any) => {
                  setIsCreateOrder(false);
                  setCustomerOnHoldModal(true);
                  setCustomerOnHoldMessage(data);
                },
              }),
            );
          }}
          quoteDisplayId={selectedQuoteData?.display_quote_id as string}
          submitting={submittingCreateOrder}
        />
      )}

      {customerOnHoldModal && (
        <CustomerOnHoldWarningModal
          visible={customerOnHoldModal}
          onClose={() => setCustomerOnHoldModal(false)}
          customerOnHoldMessage={customerOnHoldMessage}
          isCustomerDetails={true}
        />
      )}

      {profitModal && (
        <ViewProfitDataModal
          visible={!!profitModal}
          setIsModalVisible={setProfitModal as any}
          onClose={() => {
            setProfitModal(false);
            setProfitData(null);
          }}
          profitData={profitData}
        />
      )}

      {failedAddressData !== null && (
        <ModifyDeliveryAddressModal
          open={failedAddressData !== null}
          onClose={() => setFailedAddressData(null)}
          addressData={failedAddressData?.customer_snapshot?.delivery_address}
          isDistributor={false}
          onSubmitOverride={(payload, setSaving) => {
            setSaving(true);
            dispatch(
              createOrderAPI({
                payload: payload,
                onSuccess: (data) => {
                  setSaving(false);
                  setFailedAddressData(null);
                  navigate(`/orders/${data?._id}`);
                },
                onError: () => {
                  setSaving(false);
                },
                onAddressIncompleteError: (data) => {
                  setFailedAddressData(data?.data);
                },
                onDrawingRequiredError: (data) => {
                  setDrawingRequiredData(data?.data || {});
                },
              }),
            );
          }}
          quoteData={failedAddressData}
        />
      )}
      {drawingRequiredData !== null && (
        <ConfigureDrawingsModal
          open={drawingRequiredData !== null}
          onClose={() => setDrawingRequiredData(null)}
          drawingsData={drawingRequiredData?.variants_requiring_drawing}
          partsData={drawingRequiredData?.parts_requiring_drawing}
          componentsData={drawingRequiredData?.components_requiring_drawing}
          fullDrawingData={drawingRequiredData}
          quotationId={drawingRequiredData?.quote_id}
          onSubmit={(payload, setModalLoader) => {
            setModalLoader(true);
            dispatch(
              createOrderAPI({
                payload,
                onSuccess: (data) => {
                  setModalLoader(false);
                  setDrawingRequiredData(null);
                  navigate(`/orders/${data?._id}`);
                },
                onError: () => setModalLoader(false),
                onAddressIncompleteError: (data) => {
                  setModalLoader(false);
                  setDrawingRequiredData(null);
                  setFailedAddressData(data?.data);
                },
                onDrawingRequiredError: (data) => {
                  setDrawingRequiredData(data?.data || {});
                },
              }),
            );
          }}
        />
      )}
    </>
  );
};

export default ClientQuotations;
